module.exports = __webpack_public_path__ + "media/assets/socials/twitter-479b54a96b7fc7ccab3d461e8ea1458f.svg";